import {getClient} from "@project/sdk/sales";
import {GetClientResponse} from "@project/sdk/sales/zod";
import {queryOptions} from "@tanstack/react-query";

import {queryPolicyDefaults} from "../../../../../shared/query/query-policies";
import {clientKeys} from "../../../client-keys";

export function getClientQueryOptions(id: string, includeDeleted = false) {
  return queryOptions({
    ...queryPolicyDefaults.warm,
    staleTime: 0,
    queryKey: [...clientKeys.detail(id), {includeDeleted}] as const,
    queryFn: async ({signal}) =>
      GetClientResponse.parse(await getClient(id, {includeDeleted}, {signal})),
  });
}
